// extracted by mini-css-extract-plugin
export default {"LandingPageHeader":"LandingPageHeader_LandingPageHeader__kPsM-","image":"LandingPageHeader_image__DvZ0n","schlLogo":"LandingPageHeader_schlLogo__lk-Se"};